import styled from '@emotion/styled'
import { Form as AntForm, FormProps as AntFormProps } from 'antd'

interface FormProps extends AntFormProps {
  canCreate?: boolean
}

const { Item } = AntForm

export const Form = styled(AntForm, {
  shouldForwardProp: (prop) => prop !== 'canCreate'
})<FormProps>(
  ({ canCreate }) => `
    display: ${canCreate ? 'grid' : 'flex'};
    margin: ${canCreate ? '0' : '0 auto'};
    width: ${canCreate ? '100%' : 'fit-content'};
  
    flex-direction: column;
    grid-template-columns: max-content 1fr;
    grid-template-areas:
      'back .'
      'categories categories-caption'
      'schedule schedule-caption'
      'cut-off-times .'
      'save .';
    gap: 24px;
  
    transition: all 0.3s ease;
  
    .ant-form-item-label > label {
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
  
      color: #4a4a68;
    }
  
    .ant-form-item-explain.ant-form-item-explain-error {
      min-height: 14px;
      height: 14px;
      margin-bottom: 0;
    }
  
    @media (min-width: 1220px) {
      grid-template-columns: 1fr max-content minmax(360px, 1fr);
      grid-template-areas:
        '. back .'
        '. categories categories-caption'
        '. schedule schedule-caption'
        '. cut-off-times .'
        '. save .';
    }
  `
)

export const FormItem = styled(Item)`
  margin-bottom: 0;

  .ant-form-item-label {
    height: auto !important;
    min-height: auto !important;
  }

  .ant-form-item-label label {
    color: #4a4a68;
    font-weight: 500;
    font-size: 14px;

    height: auto !important;
    white-space: normal !important;
    word-wrap: break-word;
    line-height: 1.4;
  }
`
